import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-200 py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "max-w-md w-full space-y-8 bg-white p-10 rounded-md" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "flex w-full" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "flex gap-2 w-full items-center justify-between" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "shrink-0 text-black" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#000",
    "fill-opacity": "0.2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 13l3 3 7-7",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "rounded-md gap-4 flex flex-col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "Payment", -1)
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_16 = { class: "block truncate" }
const _hoisted_17 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_18 = { class: "flex-row flex gap-4" }
const _hoisted_19 = {
  class: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md items-center gap-1 text-white",
  style: {"background-color":"#3c82f6"},
  type: "submit"
}
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "m-1" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "m-1" }
const _hoisted_24 = { class: "text-sm px-1" }
const _hoisted_25 = { class: "text-sm px-1" }

import {inject, onMounted, ref, watch} from "vue";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  RadioGroup,
  RadioGroupLabel,
  RadioGroupOption,
  Switch
} from "@headlessui/vue";
import {useStore} from "vuex";
import {AxiosInstance} from "axios";

interface PaymentAccount {
  id: string
  operatorId: string
  specialCode: string
  appId: string
  secret: string
  apiUrl: string
  paymentId: string
  merchantId: string
  clientId: string
  clientSecret: string
  useWithdraw: boolean
  useDeposit: boolean
  isActive: boolean
  createdAt: string
  updatedAt: string,
  minWithdraw: number,
  minDeposit: number,
}
interface operatorPaymentConfig{
   id: number;
   operatorId: string;
   maxWithdrawCount: number;
   maxWithdrawPerMinute: number;
   maxHoldAmount: number;
   autoApproveAmount: number;
   version: number;
   bypassPaymentApprovalTotp: boolean;
   multipleDeposit: boolean;
   isAutoWithdraw: boolean;
   operatorPaymentWithdrawId: number;
   createdAt: Date
   updatedAt: CreationOptional
   resetWithdrawAtMidnight: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawConfigV3',
  setup(__props) {

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const disableWithdraw = ref({
  is_active: false
})

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const isLoading = ref(false);
const operatorPaymentConfig = ref<operatorPaymentConfig>({})
const accountList = ref<PaymentAccount[]>([]);
const form = ref<{
  withdrawAccount: PaymentAccount | null;
  mode: 'auto withdraw list'|'manual'
}>({  withdrawAccount: null, mode: null });
const disableSelectWithdrawPayment = ref<boolean>(true);
const onSave = async () => {
  isLoading.value = true;
  try {
    if (confirm("Are you sure?")) {
      const payload = {
        ...operatorPaymentConfig.value,
        isAutoWithdraw: form.value.mode === "auto withdraw list",
        operatorPaymentWithdrawId: form.value.withdrawAccount.id,
      }
      const result = await axios
      .post<operatorPaymentConfig>(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-config/update`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
      )
      .then(({ data }) => data)
      await getConfig()
      await getAccount();
    }
  } catch (error) {
    console.error('An error occurred while saving:', error);
  } finally {
    isLoading.value = false;
  }
};


const onCancel = async () => {
  await getConfig()
  await getAccount()
}

const getAccount = async () => {
  isLoading.value = true
  let payload = {
    operatorId: store.state.selectedOperator.operatorId,
  }
  const result = await axios
    .post<PaymentAccount[]>(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/operator`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(({ data }) => data)

  form.value.withdrawAccount = result.find((pa: PaymentAccount) => pa.id == operatorPaymentConfig.value.operatorPaymentWithdrawId) || null
  accountList.value = result
  isLoading.value = false
}

const getConfig = async () => {
  const result = await axios
  .post<operatorPaymentConfig>(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-config/${store.state.selectedOperator.operatorId}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
  )
  .then(({ data }) => data)
  operatorPaymentConfig.value = result
  if(operatorPaymentConfig.value.isAutoWithdraw===true) {
    disableSelectWithdrawPayment.value = true
    form.value.mode = 'auto withdraw list'
  }else{
    form.value.mode = 'manual'
    disableSelectWithdrawPayment.value = false
  }
  // store.state.selectedOperator.
  // console.log(disableSelectWithdrawPayment.value)
  // console.log(`************************`)
}

const getAllowPayment = async () => {
  isLoading.value = true
  const result = await axios
  .post<operatorPaymentConfig>(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/operator/read/payment-allow`,
      {operatorId: store.state.selectedOperator.operatorId},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
  )
  .then(({ data }) => data)
  disableWithdraw.value = result.result[0].allowWithdraw
  isLoading.value = false
  // operatorPaymentConfig.value = result
  // if(operatorPaymentConfig.value.isAutoWithdraw===true) {
  //   disableSelectWithdrawPayment.value = true
  //   form.value.mode = 'auto'
  // }else{
  //   form.value.mode = 'manual'
  //   disableSelectWithdrawPayment.value = false
  // }
  // store.state.selectedOperator.
  // console.log(disableSelectWithdrawPayment.value)
  // console.log(`************************`)
}
const onToggleWithdraw = async () => {
  if (confirm("Are you sure?")) {
    await toggleDisableWithdraw()
  } else {
    return
  }
}

const toggleDisableWithdraw = async () => {
    try {
      isLoading.value = true
      let payload = {
        operatorId: store.state.selectedOperator.operatorId,
        allowWithdraw: !disableWithdraw.value,
        allowDeposit: undefined
      }
      const { data } = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/operator/update/payment-allow`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
      )
      console.log(data)
      if (!data) {
        throw new Error('err')
      }

      await getAllowPayment()
      isLoading.value = false
    } catch (error) {
      alert("update failed")
      isLoading.value = false
    }
}

onMounted( async () => {
  await getAllowPayment()
  await getConfig()
  await getAccount()
})

watch(
    () => form.value.mode,
    () => {
      if(form.value.mode === 'auto withdraw list') {
        disableSelectWithdrawPayment.value = true
      }
      else{
        disableSelectWithdrawPayment.value = false
      }
    }
);

return (_ctx: any,_cache: any) => {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("messages.navigation.withdrawConfig")) + " ", 1),
      _createElementVNode("form", {
        action: "#",
        class: "mt-8 space-y-6",
        method: "POST",
        onSubmit: _withModifiers(onSave, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(RadioGroup), {
            class: "w-full",
            modelValue: form.value.mode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.mode) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['auto withdraw list', 'manual'], (plan) => {
                  return _createVNode(_unref(RadioGroupOption), {
                    as: "template",
                    key: plan,
                    value: plan
                  }, {
                    default: _withCtx(({ active, checked }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass([[
                active
                  ? 'ring-2 ring-white/60 ring-offset-2 ring-offset-sky-300'
                  : '',
                checked ? 'bg-blue-400 text-white' : 'bg-white ',
              ], "relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md focus:outline-none"])
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_unref(RadioGroupLabel), {
                                as: "p",
                                class: _normalizeClass([checked ? 'text-white' : 'text-gray-900', "font-medium"])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(plan), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ])
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_11, 512), [
                            [_vShow, checked]
                          ])
                        ])
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _hoisted_13,
            _createVNode(_unref(Listbox), {
              class: "relative",
              modelValue: form.value.withdrawAccount,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.withdrawAccount) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(ListboxButton), {
                    class: _normalizeClass(["w-full py-2 pl-3 text-left rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm", disableSelectWithdrawPayment.value? 'bg-gray-300': 'bg-white']),
                    disabled: disableSelectWithdrawPayment.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(form.value.withdrawAccount?.appId ? `${form.value.withdrawAccount?.appId}  (${form.value.withdrawAccount?.paymentName})
                      ` : '-'), 1),
                        _createVNode(_component_SelectorIcon, {
                          "aria-hidden": "true",
                          class: "w-5 h-5 text-gray-400 ml-auto"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"]),
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ListboxOptions), {
                        class: "absolute w-full max-h-60 mt-1 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                        style: {"z-index":"100"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountList.value, (account) => {
                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                              key: account.id,
                              value: account,
                              as: "template"
                            }, {
                              default: _withCtx(({ active, selected }) => [
                                _createElementVNode("li", {
                                  class: _normalizeClass([
                        active
                          ? 'text-amber-900 bg-amber-100'
                          : 'text-gray-900',
                        'cursor-default select-none relative py-2 pl-10 pr-4',
                      ])
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                          selected ? 'font-medium' : 'font-normal',
                          'block truncate',
                        ])
                                  }, _toDisplayString(`${account.appId} (${account.paymentName})`), 3),
                                  selected
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                        _createVNode(_unref(CheckIcon), {
                                          "aria-hidden": "true",
                                          class: "w-5 h-5"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white",
            style: {"background-color":"#ef5050"},
            type: "reset",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onCancel()))
          }, _toDisplayString(_ctx.$t("messages.paymentConfig.cancel")), 1),
          _createElementVNode("button", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("messages.paymentConfig.save")), 1),
            _withDirectives(_createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'circle-notch'],
              class: "text-white",
              spin: ""
            }, null, 512), [
              [_vShow, isLoading.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("messages.paymentConfig.withdraw")), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("messages.paymentConfig.close")), 1),
            _createVNode(_unref(Switch), {
              "model-value": disableWithdraw.value,
              "onUpdate:modelValue": onToggleWithdraw,
              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", disableWithdraw.value ? 'bg-green-500' : 'bg-red-500'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass([disableWithdraw.value ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["model-value", "class"]),
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("messages.paymentConfig.open")), 1)
          ])
        ])
      ], 40, _hoisted_3)
    ])
  ]))
}
}

})